export default function isIOS(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    'platform' in navigator &&
    /iPhone|iPod|iPad/.test(navigator.platform)
  );
}
